import styled from 'styled-components'

export const LogoContainer = styled.div(({ size }) => ({
  textAlign: 'center',
  marginBottom: '2.5rem',
  width: size
}))
